<template>
  <!-- 丰富的软件设备 -->
  <div class="software">
    <div class="header">
      <div class="title">丰富的软件设备</div>
      <div class="border"></div>
    </div>
    <div class="list">
      <div
        class="item"
        v-for="item in softwareList"
        :key="item.id"
        :style="`background-image: url(${item.open});`"
      >
        <img class="logo" :src="item.logo" alt="" />
        <div class="title" :style="'color: #fff'">
          {{ item.title }}
        </div>
        <div class="text" :style="'color: #B6BEC7'">
          {{ item.text }}
        </div>
        <router-link :to="item.path">
        <div class="more" :style="'color: #fff'">
          <div>了解更多</div>
          <img :src="more" alt="" />
        </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import softwareLogo1 from "../../../assets/home/softwareLogo1.png";
import softwareLogo2 from "../../../assets/home/softwareLogo2.png";
import softwareLogo3 from "../../../assets/home/softwareLogo3.png";

import softwareOpen1 from "../../../assets/home/softwareOpen1.png";
import softwareOpen2 from "../../../assets/home/softwareOpen2.png";
import softwareOpen3 from "../../../assets/home/softwareOpen3.png";

import more from "../../../assets/home/more.png";

export default {
  setup() {
    return reactive({
      more: more,
      softwareList: [
        {
          id: 1,
          title: "物业办公APP",
          text: "员工随时随地处理工作，工单线上流转与管理，减少线下沟通成本",
          logo: softwareLogo1,
          open: softwareOpen1,
          path: '/mobile/product/property'
        },
        {
          id: 2,
          title: "业主生活APP",
          text: "物业服务+生活服务+社区商城，为业主提供一站式服务",
          logo: softwareLogo2,
          open: softwareOpen2,
          path: '/mobile/product/resident'
        },
        {
          id: 3,
          title: "后台管理系统",
          text: "在线查看统计数据，将信息清晰、简单化，帮助物业居委轻松管理社区",
          logo: softwareLogo3,
          open: softwareOpen3,
          path: '/mobile/product/workorder'
        },
      ],
    });
  },
};
</script>

<style scoped>
.software {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 5px auto 0;
}
.list {
  margin-top: 16px;
}
.list .item {
  height: 320px;
  padding: 32px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background-position: center;
}
.list .item .logo {
  width: 65px;
}
.list .item .title {
  font-size: 16px;
  margin-top: 16px;
}
.list .item .text {
  font-size: 12px;
  margin-top: 32px;
  line-height: 24px;
}
.list .item .more {
  font-size: 14px;
  margin-top: 100px;
  color: #248efb;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.list .item .more img {
  width: 14px;
  margin-left: 8px;
}
</style>
